import React from 'react';
import { IconMap, IconSquare } from '@tabler/icons-react';

// Portrait/landscape format toggle extracted from CreatePage's `format-selection-section`.
// The parent's onChangeFormat handler does any side effects (CreatePage resets 3D prep
// state there); this component only surfaces the choice.
function FormatSelectionSection({
  title = 'Choose format',
  format,
  onChangeFormat,
  portraitLabel = 'Portrait Map (4:5)',
  landscapeLabel = 'Landscape Map',
}) {
  return (
    <div className="format-selection-section">
      <h2 className="section-title">{title}</h2>
      <div className="format-toggle">
        <button
          className={`format-option ${format === 'portrait' ? 'selected' : ''}`}
          onClick={() => onChangeFormat?.('portrait')}
        >
          <IconSquare size={24} />
          <span>{portraitLabel}</span>
          {format === 'portrait' && <div className="selection-check">✓</div>}
        </button>
        <button
          className={`format-option ${format === 'landscape' ? 'selected' : ''}`}
          onClick={() => onChangeFormat?.('landscape')}
        >
          <IconMap size={24} />
          <span>{landscapeLabel}</span>
          {format === 'landscape' && <div className="selection-check">✓</div>}
        </button>
      </div>
    </div>
  );
}

export default FormatSelectionSection;
